module.exports = __webpack_public_path__ + "img/forge-badge.01428723.png";